<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
@if (loadingCaseDetails || loadingFollowupDetails || loadingFCTDetails) {
<div class="loader text-center">
	<img src="../../../assets/img/loading.gif" style="width: 100px;" />
	<p style="color: black;font-weight: bolder;">Loading...</p>
</div>
}
@if (navbar.userAccess?.FCT=='Full' || navbar.userAccess?.FCT=='Readonly') {
<div class="row">
	<div class="col-6 main-col">
		<div class="card">
			<div class="card-header mb-0">
				<h5 class="card-title mb-0">
					{{pagetitle}}
					<span class="float-end text-dark me-3 mt-1">
						Case-Id:
						<strong>
							{{caseDetails?.case_id}}
						</strong>
					</span>
					<span class="float-end text-dark me-3 mt-1">
						<strong>
							<fa-icon [icon]="['fas',caseDetails?.status==2?'lock':'lock-open']"
								[matTooltip]="caseDetails?.case_status">
							</fa-icon>
						</strong>
					</span>
				</h5>
			</div>
			<div class="card-body pt-2">
				<form [formGroup]="moduleForm" (ngSubmit)="onSubmit()">
					<ng-container *ngTemplateOutlet="actionButtons"></ng-container>
					<ul class="nav nav-tabs nav-tabs-bordered">
						<li class="nav-item" role="button" (click)="setActiveTab(0)">
							<a class="nav-link" [ngClass]="getTabClass(0)">
								Details
							</a>
						</li>
						<li class="nav-item" role="button" (click)="setActiveTab(1)">
							<a class="nav-link" [ngClass]="getTabClass(1)">
								Human Anatomy
							</a>
						</li>
						<li class="nav-item" role="button" (click)="setActiveTab(2)">
							<a class="nav-link" [ngClass]="getTabClass(2)">
								Range of Motion
							</a>
						</li>
					</ul>
					<div class="tab-content">
						<div id="tab0" class="tab-pane" [ngClass]="getTabPaneClass(0)">
							<div class="p-4">
								<mat-accordion [hideToggle]="false">
									<mat-expansion-panel [expanded]="true">
										<mat-expansion-panel-header class="bg-theme" [collapsedHeight]="'35px'"
											[expandedHeight]="'40px'">
											<mat-panel-title>
												<strong class="text-white">
													<fa-icon [icon]="['fas','user']"></fa-icon>
													Candidate Details
												</strong>
											</mat-panel-title>
										</mat-expansion-panel-header>
										<div class="card border shadow-sm card-body p-0 mt-2">
											<div class="row g-0">
												<div
													class="col-md-3 border-end d-flex flex-column p-2 bg-light-subtle gap-3">
													<div class="text-center">
														<span class="d-block text-muted small fw-bold mb-1">
															Photo
															<fa-icon [icon]="['fas','edit']" matTooltip="Change"
																role="button" (click)="openImageModal('photo')">
															</fa-icon>
														</span>
														<div class="border rounded bg-white p-2 d-flex align-items-center justify-content-center shadow-sm"
															style="height: 100px;">
															@if (f.candidate_photo.value) {
															<a [href]="File_Storage_URL + f.candidate_photo.value"
																target="_blank" matTooltip="Click to view"
																class="d-inline-flex align-items-center justify-content-center w-100 h-100 text-decoration-none">
																<img [src]="File_Storage_URL + f.candidate_photo.value"
																	alt="Candidate Photo"
																	class="img-fluid mh-100 object-fit-contain" />
															</a>
															} @else {
															<span class="text-muted small">
																No Photo Available
															</span>
															}
														</div>
													</div>
													<div class="text-center">
														<span class="d-block text-muted small fw-bold mb-1">
															Signature
															<fa-icon [icon]="['fas','edit']" matTooltip="Change"
																role="button" (click)="openImageModal('sign')">
															</fa-icon>
														</span>
														<div class="border rounded bg-white p-2 d-flex align-items-center justify-content-center shadow-sm"
															style="height: 75px;">
															@if (f.candidate_signature.value) {
															<a [href]="File_Storage_URL + f.candidate_signature.value"
																target="_blank" matTooltip="Click to view"
																class="d-inline-flex align-items-center justify-content-center w-100 h-100 text-decoration-none">
																<img [src]="File_Storage_URL + f.candidate_signature.value"
																	alt="Candidate Signature"
																	class="img-fluid mh-100 object-fit-contain" />
															</a>
															} @else {
															<span class="text-muted small">
																No Signature
															</span>
															}
														</div>
													</div>
												</div>
												<div class="col-md-9">
													<div class="row g-0 border-bottom">
														<div class="col">
															<div
																class="py-2 px-4 d-flex justify-content-between align-items-center">
																<span class="text-muted small fw-bold mb-1">
																	Full Name
																</span>
																<span class="fw-semibold text-dark">
																	{{ caseDetails?.f_name }} {{ caseDetails?.l_name }}
																</span>
															</div>
														</div>
													</div>
													<div class="row g-0 border-bottom">
														<div class="col">
															<div
																class="py-2 px-4 d-flex justify-content-between align-items-center">
																<span class="text-muted small fw-bold mb-1">
																	Date of Birth
																</span>
																<span class="fw-semibold text-dark">
																	{{caseDetails?.dob || "___"}}
																</span>
															</div>
														</div>
													</div>
													<div class="row g-0 border-bottom">
														<div class="col">
															<div
																class="py-2 px-4 d-flex justify-content-between align-items-center">
																<span class="text-muted small fw-bold mb-1">
																	Gender
																</span>
																<span class="fw-semibold text-dark">
																	{{ caseDetails?.gender || "___" }}
																</span>
															</div>
														</div>
													</div>
													<div class="row g-0 border-bottom">
														<div class="col">
															<div
																class="py-2 px-4 d-flex justify-content-between align-items-center">
																<span class="text-muted small fw-bold mb-1">
																	Rank
																</span>
																<span class="fw-semibold text-dark">
																	{{ caseDetails?.rank_name || "___" }}
																</span>
															</div>
														</div>
													</div>
													<div class="row g-0 border-bottom">
														<div class="col">
															<div
																class="py-2 px-4 d-flex justify-content-between align-items-center">
																<span class="text-muted small fw-bold mb-1">
																	Nationality
																</span>
																<span class="fw-semibold text-dark">
																	{{
																	followUpDetails?.case_id?.candidate?.nationality_name
																	||
																	"___"
																	}}
																</span>
															</div>
														</div>
													</div>
													<div class="row g-0 border-bottom">
														<div class="col">
															<div
																class="py-2 px-4 d-flex justify-content-between align-items-center">
																<span class="text-muted small fw-bold mb-1">
																	Vessel Name
																</span>
																<span class="fw-semibold text-dark">
																	{{ caseDetails?.vessel || "___" }}
																</span>
															</div>
														</div>
													</div>
													<div class="row g-0 border-bottom">
														<div class="col">
															<div
																class="py-2 px-4 d-flex justify-content-between align-items-center">
																<span class="text-muted small fw-bold mb-1">
																	Crew Id.
																</span>
																<span class="fw-semibold text-dark">
																	{{ followUpDetails?.case_id?.crew_id || "___" }}
																</span>
															</div>
														</div>
													</div>
													<div class="row g-0 border-bottom">
														<div class="col">
															<div
																class="py-2 px-4 d-flex justify-content-between align-items-center border-bottom">
																<label for="fitness_status"
																	class="fw-bold small me-2 mb-0 col-5">
																	Medical Profile
																</label>
																<div class="w-100">
																	<input type="text" id="medical_profile"
																		[ngClass]="{'is-invalid':showError('medical_profile')}"
																		class="form-control form-control-sm"
																		formControlName="medical_profile"
																		placeholder="Enter Medical Profile" />
																	@if (showError('medical_profile')) {
																	<p class="text-danger small mb-0 mt-1">
																		@if (f.medical_profile.errors?.required) {
																		<span>Required</span>
																		}
																		@if (f.medical_profile.errors?.incorrect) {
																		<span>{{customError.medical_profile}}</span>
																		}
																	</p>
																	}
																</div>
															</div>
														</div>
													</div>
													<div class="row g-0 border-bottom">
														<div class="col">
															<div
																class="py-2 px-4 d-flex justify-content-between align-items-center border-bottom">
																<label for="fitness_status"
																	class="fw-bold small me-2 mb-0 col-5">
																	Location of Test
																</label>
																<div class="w-100">
																	<input type="text" id="location_of_test"
																		[ngClass]="{'is-invalid':showError('location_of_test')}"
																		class="form-control form-control-sm"
																		formControlName="location_of_test"
																		placeholder="Enter Location of Test" />
																	@if (showError('location_of_test')) {
																	<p class="text-danger small mb-0 mt-1">
																		@if (f.location_of_test.errors?.required) {
																		<span>Required</span>
																		}
																		@if (f.location_of_test.errors?.incorrect) {
																		<span>{{customError.location_of_test}}</span>
																		}
																	</p>
																	}
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</mat-expansion-panel>
									<mat-expansion-panel [expanded]="false">
										<mat-expansion-panel-header class="bg-theme" [collapsedHeight]="'35px'"
											[expandedHeight]="'40px'">
											<mat-panel-title>
												<strong class="text-white">
													<fa-icon [icon]="['fas','user-md']"></fa-icon>
													Medical Examiner's Details
												</strong>
											</mat-panel-title>
										</mat-expansion-panel-header>
										<div class="card border shadow-sm mb-4 card-body p-0 mt-2">
											<div class="row g-0 border-bottom">
												<div class="col">
													<div
														class="py-2 px-4 d-flex align-items-center justify-content-between">
														<label for="examining_doctor_id"
															class="fw-bold small me-2 mb-0 col-5">
															Doctor
														</label>
														<div class="w-100">
															<ng-select
																[ngClass]="{'is-invalid':showError('examining_doctor_id')}"
																[items]="doctorList" bindLabel="name" bindValue="id"
																[clearable]="true" id="examining_doctor_id"
																formControlName="examining_doctor_id"
																placeholder="Select Doctor" [appearance]="'outline'"
																(change)="getDoctorDetails()">
															</ng-select>
															@if (showError('examining_doctor_id')) {
															<p class="text-danger small mb-0 mt-1">
																@if (f.examining_doctor_id.errors?.required) {
																<span>Required</span>
																}
																@if (f.examining_doctor_id.errors?.incorrect) {
																<span>{{customError.examining_doctor_id}}</span>
																}
															</p>
															}
														</div>
													</div>
												</div>
											</div>
											<div class="row g-0 border-bottom">
												<div class="col">
													<div
														class="py-2 px-4 d-flex justify-content-between align-items-center">
														<span class="small fw-bold mb-1">
															Medical License No.
														</span>
														<span class="fw-semibold text-dark">
															{{ selectedDoctorDetails?.licence_no || "___" }}
														</span>
													</div>
												</div>
											</div>
											<div class="row g-0 border-bottom">
												<div class="col">
													<div
														class="py-2 px-4 d-flex justify-content-between align-items-center">
														<span class="fw-bold small me-3">
															Physical Examination Done?
														</span>
														<div>
															<mat-radio-group
																formControlName="is_physical_examination_done"
																class="d-flex gap-3">
																<mat-radio-button [value]="true" class="color-success">
																	YES
																</mat-radio-button>
																<mat-radio-button [value]="false" class="color-danger">
																	NO
																</mat-radio-button>
															</mat-radio-group>
															@if (showError('is_physical_examination_done')) {
															<p class="text-danger small mb-0 mt-1">
																@if (f.is_physical_examination_done.errors?.required) {
																<span>Required</span>
																}
																@if (f.is_physical_examination_done.errors?.incorrect) {
																<span>{{customError.is_physical_examination_done}}</span>
																}
															</p>
															}
														</div>
													</div>
												</div>
											</div>
											<div class="row g-0 border-bottom">
												<div class="col">
													<div
														class="py-2 px-4 d-flex justify-content-between align-items-center">
														<span class="fw-bold small me-3">
															Medical History Taken and Reviewed?
														</span>
														<div>
															<mat-radio-group formControlName="is_medical_history_taken"
																class="d-flex gap-3">
																<mat-radio-button [value]="true" class="color-success">
																	YES
																</mat-radio-button>
																<mat-radio-button [value]="false" class="color-danger">
																	NO
																</mat-radio-button>
															</mat-radio-group>
															@if (showError('is_medical_history_taken')) {
															<p class="text-danger small mb-0 mt-1">
																@if (f.is_medical_history_taken.errors?.required) {
																<span>Required</span>
																}
																@if (f.is_medical_history_taken.errors?.incorrect) {
																<span>{{customError.is_medical_history_taken}}</span>
																}
															</p>
															}
														</div>
													</div>
												</div>
											</div>
											<div class="row g-0 border-bottom">
												<div class="col">
													<div
														class="py-2 px-4 d-flex justify-content-between align-items-center">
														<span class="fw-bold small me-3">
															Blood Investigations Done and Reviewed?
														</span>
														<div>
															<mat-radio-group
																formControlName="is_blood_investigation_done"
																class="d-flex gap-3">
																<mat-radio-button [value]="true" class="color-success">
																	YES
																</mat-radio-button>
																<mat-radio-button [value]="false" class="color-danger">
																	NO
																</mat-radio-button>
															</mat-radio-group>
															@if (showError('is_blood_investigation_done')) {
															<p class="text-danger small mb-0 mt-1">
																@if (f.is_blood_investigation_done.errors?.required) {
																<span>Required</span>
																}
																@if (f.is_blood_investigation_done.errors?.incorrect) {
																<span>{{customError.is_blood_investigation_done}}</span>
																}
															</p>
															}
														</div>
													</div>
												</div>
											</div>
											<div class="row g-0 border-bottom">
												<div class="col">
													<div
														class="py-2 px-4 d-flex justify-content-between align-items-center">
														<span class="fw-bold small me-3">
															Scans and Checks Done and Reviewed?
														</span>
														<div>
															<mat-radio-group formControlName="is_scans_done"
																class="d-flex gap-3">
																<mat-radio-button [value]="true" class="color-success">
																	YES
																</mat-radio-button>
																<mat-radio-button [value]="false" class="color-danger">
																	NO
																</mat-radio-button>
															</mat-radio-group>
															@if (showError('is_scans_done')) {
															<p class="text-danger small mb-0 mt-1">
																@if (f.is_scans_done.errors?.required) {
																<span>Required</span>
																}
																@if (f.is_scans_done.errors?.incorrect) {
																<span>{{customError.is_scans_done}}</span>
																}
															</p>
															}
														</div>
													</div>
												</div>
											</div>
										</div>
									</mat-expansion-panel>
									<mat-expansion-panel [expanded]="false">
										<mat-expansion-panel-header class="bg-theme" [collapsedHeight]="'35px'"
											[expandedHeight]="'40px'">
											<mat-panel-title>
												<strong class="text-white">
													<fa-icon [icon]="['fas','notes-medical']"></fa-icon>
													Functional Capacity Test Overview
												</strong>
											</mat-panel-title>
										</mat-expansion-panel-header>
										<div class="card border shadow-sm mb-4 card-body p-0 mt-2">
											<div class="row g-0 border-bottom">
												<div class="col">
													<div
														class="py-2 px-4 d-flex justify-content-between align-items-center border-bottom">
														<label for="fitness_status"
															class="fw-bold small me-2 mb-0 col-5">
															Fitness Status
														</label>
														<div class="w-100">
															<input type="text" id="fitness_status"
																[ngClass]="{'is-invalid':showError('fitness_status')}"
																class="form-control form-control-sm"
																formControlName="fitness_status"
																placeholder="Enter Fitness Status" />
															@if (showError('fitness_status')) {
															<p class="text-danger small mb-0 mt-1">
																@if (f.fitness_status.errors?.required) {
																<span>Required</span>
																}
																@if (f.fitness_status.errors?.incorrect) {
																<span>{{customError.fitness_status}}</span>
																}
															</p>
															}
														</div>
													</div>
													<div
														class="py-2 px-4 d-flex justify-content-between align-items-center border-bottom">
														<label for="fitness_date" class="fw-bold small me-2 mb-0 col-5">
															Fitness Date
														</label>
														<div class="w-100">
															<div class="input-group input-group-sm">
																<input class="form-control"
																	[ngClass]="{'is-invalid':showError('fitness_date')}"
																	placeholder="" formControlName="fitness_date"
																	ngbDatepicker id="fitness_date"
																	#fitness_date="ngbDatepicker" [minDate]="minDate"
																	[container]="'body'" />
																<button class="btn btn-outline-secondary"
																	(click)="fitness_date.toggle()" type="button">
																	<fa-icon
																		[icon]="['fas', 'calendar-week']"></fa-icon>
																</button>
															</div>
															@if (showError('fitness_date')) {
															<p class="text-danger small mb-0 mt-1">
																@if (f.fitness_date.errors?.required) {
																<span>Required</span>
																}
																@if (f.fitness_date.errors?.incorrect) {
																<span>{{customError.fitness_date}}</span>
																}
															</p>
															}
														</div>
													</div>
													<div
														class="py-2 px-4 d-flex justify-content-between align-items-center border-bottom">
														<label for="fitness_valid_date"
															class="fw-bold small me-2 mb-0 col-5">
															Fitness Valid Till Date
														</label>
														<div class="w-100">
															<div class="input-group input-group-sm">
																<input class="form-control"
																	[ngClass]="{'is-invalid':showError('fitness_valid_date')}"
																	placeholder="" formControlName="fitness_valid_date"
																	ngbDatepicker id="fitness_valid_date"
																	#fitness_valid_date="ngbDatepicker"
																	[minDate]="minDate" [container]="'body'" />
																<button class="btn btn-outline-secondary"
																	(click)="fitness_valid_date.toggle()" type="button">
																	<fa-icon
																		[icon]="['fas', 'calendar-week']"></fa-icon>
																</button>
															</div>
															@if (showError('fitness_valid_date')) {
															<p class="text-danger small mb-0 mt-1">
																@if (f.fitness_valid_date.errors?.required) {
																<span>Required</span>
																}
																@if (f.fitness_valid_date.errors?.incorrect) {
																<span>{{customError.fitness_valid_date}}</span>
																}
															</p>
															}
														</div>
													</div>
													<div
														class="py-2 px-4 d-flex justify-content-between align-items-center border-bottom">
														<span class="fw-bold small me-2 col-7">
															Details Physical Examination Done?
														</span>
														<div>
															<mat-radio-group formControlName="physical_examination_done"
																class="d-flex gap-3">
																<mat-radio-button [value]="true" class="color-success">
																	YES
																</mat-radio-button>
																<mat-radio-button [value]="false" class="color-danger">
																	NO
																</mat-radio-button>
															</mat-radio-group>
															@if (showError('physical_examination_done')) {
															<p class="text-danger small mb-0 mt-1">
																@if (f.physical_examination_done.errors?.required)
																{
																<span>Required</span>
																}
																@if (f.physical_examination_done.errors?.incorrect)
																{
																<span>{{customError.physical_examination_done}}</span>
																}
															</p>
															}
														</div>
													</div>
													<div
														class="py-2 px-4 d-flex justify-content-between align-items-center border-bottom">
														<span class="fw-bold small me-2 col-7">
															Any Restrictions
														</span>
														<div>
															<mat-radio-group formControlName="any_restrictions"
																class="d-flex gap-3">
																<mat-radio-button [value]="true" class="color-success">
																	YES
																</mat-radio-button>
																<mat-radio-button [value]="false" class="color-danger">
																	NO
																</mat-radio-button>
															</mat-radio-group>
															@if (showError('any_restrictions')) {
															<p class="text-danger small mb-0 mt-1">
																@if (f.any_restrictions.errors?.required) {
																<span>Required</span>
																}
																@if (f.any_restrictions.errors?.incorrect) {
																<span>{{customError.any_restrictions}}</span>
																}
															</p>
															}
														</div>
													</div>
													<div
														class="py-2 px-4 d-flex justify-content-between align-items-center border-bottom">
														<span class="fw-bold small me-2 col-7">
															X-Ray Report / Image Attached?
														</span>
														<div>
															<mat-radio-group formControlName="is_x_ray_report_attached"
																class="d-flex gap-3">
																<mat-radio-button [value]="true" class="color-success">
																	YES
																</mat-radio-button>
																<mat-radio-button [value]="false" class="color-danger">
																	NO
																</mat-radio-button>
															</mat-radio-group>
															@if (showError('is_x_ray_report_attached')) {
															<p class="text-danger small mb-0 mt-1">
																@if (f.is_x_ray_report_attached.errors?.required) {
																<span>Required</span>
																}
																@if (f.is_x_ray_report_attached.errors?.incorrect) {
																<span>{{customError.is_x_ray_report_attached}}</span>
																}
															</p>
															}
														</div>
													</div>
													<div
														class="py-2 px-4 d-flex justify-content-between align-items-center border-bottom">
														<span class="fw-bold small me-2 col-7">
															E.C.G. Attached?
														</span>
														<div>
															<mat-radio-group formControlName="is_ecg_attached"
																class="d-flex gap-3">
																<mat-radio-button [value]="true" class="color-success">
																	YES
																</mat-radio-button>
																<mat-radio-button [value]="false" class="color-danger">
																	NO
																</mat-radio-button>
															</mat-radio-group>
															@if (showError('is_ecg_attached')) {
															<p class="text-danger small mb-0 mt-1">
																@if (f.is_ecg_attached.errors?.required) {
																<span>Required</span>
																}
																@if (f.is_ecg_attached.errors?.incorrect) {
																<span>{{customError.is_ecg_attached}}</span>
																}
															</p>
															}
														</div>
													</div>
													<div
														class="py-2 px-4 d-flex justify-content-between align-items-center border-bottom">
														<span class="fw-bold small me-2 col-7">
															Sonography Image / Report Attached?
														</span>
														<div>
															<mat-radio-group formControlName="is_sonography_attached"
																class="d-flex gap-3">
																<mat-radio-button [value]="true" class="color-success">
																	YES
																</mat-radio-button>
																<mat-radio-button [value]="false" class="color-danger">
																	NO
																</mat-radio-button>
															</mat-radio-group>
															@if (showError('is_sonography_attached')) {
															<p class="text-danger small mb-0 mt-1">
																@if (f.is_sonography_attached.errors?.required) {
																<span>Required</span>
																}
																@if (f.is_sonography_attached.errors?.incorrect) {
																<span>{{customError.is_sonography_attached}}</span>
																}
															</p>
															}
														</div>
													</div>
													<div
														class="py-2 px-4 d-flex justify-content-between align-items-center border-bottom">
														<span class="fw-bold small me-2 col-7">
															Lab Reports & Formats Attached?
														</span>
														<div>
															<mat-radio-group formControlName="is_lab_reports_attached"
																class="d-flex gap-3">
																<mat-radio-button [value]="true" class="color-success">
																	YES
																</mat-radio-button>
																<mat-radio-button [value]="false" class="color-danger">
																	NO
																</mat-radio-button>
															</mat-radio-group>
															@if (showError('is_lab_reports_attached')) {
															<p class="text-danger small mb-0 mt-1">
																@if (f.is_lab_reports_attached.errors?.required) {
																<span>Required</span>
																}
																@if (f.is_lab_reports_attached.errors?.incorrect) {
																<span>{{customError.is_lab_reports_attached}}</span>
																}
															</p>
															}
														</div>
													</div>
													<div
														class="py-2 px-4 d-flex justify-content-between align-items-center border-bottom">
														<span class="fw-bold small me-2 col-7">
															Spirometry & Audiometry Report Attached?
														</span>
														<div>
															<mat-radio-group
																formControlName="is_spirometry_reports_attached"
																class="d-flex gap-3">
																<mat-radio-button [value]="true" class="color-success">
																	YES
																</mat-radio-button>
																<mat-radio-button [value]="false" class="color-danger">
																	NO
																</mat-radio-button>
															</mat-radio-group>
															@if (showError('is_spirometry_reports_attached')) {
															<p class="text-danger small mb-0 mt-1">
																@if (f.is_spirometry_reports_attached.errors?.required)
																{
																<span>Required</span>
																}
																@if (f.is_spirometry_reports_attached.errors?.incorrect)
																{
																<span>{{customError.is_spirometry_reports_attached}}</span>
																}
															</p>
															}
														</div>
													</div>
													<div
														class="py-2 px-4 d-flex justify-content-between align-items-center border-bottom">
														<span class="fw-bold small me-2 col-7">
															Medications Prescribed (Mension in notes)
														</span>
														<div>
															<mat-radio-group formControlName="is_medications_prescribed"
																class="d-flex gap-3">
																<mat-radio-button [value]="true" class="color-success">
																	YES
																</mat-radio-button>
																<mat-radio-button [value]="false" class="color-danger">
																	NO
																</mat-radio-button>
															</mat-radio-group>
															@if (showError('is_medications_prescribed')) {
															<p class="text-danger small mb-0 mt-1">
																@if (f.is_medications_prescribed.errors?.required) {
																<span>Required</span>
																}
																@if (f.is_medications_prescribed.errors?.incorrect) {
																<span>{{customError.is_medications_prescribed}}</span>
																}
															</p>
															}
														</div>
													</div>
													<div
														class="py-2 px-4 d-flex align-items-center justify-content-between">
														<span class="fw-bold small me-2 col-7">
															Any Allergies Noted / Declared?
														</span>
														<div>
															<mat-radio-group formControlName="is_allergies_noted"
																class="d-flex gap-3">
																<mat-radio-button [value]="true" class="color-success">
																	YES
																</mat-radio-button>
																<mat-radio-button [value]="false" class="color-danger">
																	NO
																</mat-radio-button>
															</mat-radio-group>
															@if (showError('is_allergies_noted')) {
															<p class="text-danger small mb-0 mt-1">
																@if (f.is_allergies_noted.errors?.required) {
																<span>Required</span>
																}
																@if (f.is_allergies_noted.errors?.incorrect) {
																<span>{{customError.is_allergies_noted}}</span>
																}
															</p>
															}
														</div>
													</div>
												</div>
											</div>
											<div class="row g-0">
												<div class="col">
													<div class="p-4 h-100 d-flex flex-column">
														<label for="examiner_notes"
															class="fw-bold small text-dark mb-2">
															EXAMINER NOTES:
														</label>
														<p class="text-muted small mb-3"
															style="font-size: 11px; line-height: 1.4;">
															Please mention if you are aware of any medical concern
															likely to
															affect the candidate during his contract at sea based on,
															your
															interaction with candidate, detailed physical examination,
															lab
															investigations or any past medical history / treatment not
															otherwise
															mentioned in the report.
														</p>
														<quill-editor id="examiner_notes"
															[ngClass]="{'is-invalid': showError('examiner_notes')}"
															rows="14" formControlName="examiner_notes"
															placeholder="Type examiner notes here..."
															class="flex-grow-1 p-3"
															[modules]="quillConfig"></quill-editor>
														@if (showError('examiner_notes')) {
														<p class="text-danger small mb-0 mt-4">
															@if (f.examiner_notes.errors?.required) {
															<span>Required</span>
															}
															@if (f.examiner_notes.errors?.incorrect) {
															<span>{{customError.examiner_notes}}</span>
															}
														</p>
														}
													</div>
												</div>
											</div>
											<br />
											<br />
										</div>
									</mat-expansion-panel>
								</mat-accordion>
							</div>
						</div>
						<div id="tab1" class="tab-pane" [ngClass]="getTabPaneClass(1)">
							<div class="p-4">
								<div class="card border shadow-sm mb-4">
									<div class="card-header bg-theme py-2 px-4 text-center border-bottom">
										<h6 class="card-title mb-0 fw-bold text-light">
											<i class="bi bi-person-arms-up"></i>
											Human Anatomy
										</h6>
									</div>
									<div class="card-body p-3">
										<div class="row g-3">
											<div class="col">
												<div class="p-2 h-100">
													<div
														class="border h-100 p-3 rounded bg-light d-flex flex-column justify-content-between">
														<div>
															<label class="small text-secondary mb-2">
																<span>
																	Mark areas on the Body Map to record observations of
																	any
																	<strong>
																		Scarring / Burns / Swelling / Injury / Pain /
																		Abnormality / Skin Infection / or Other relevant
																		findings
																	</strong>
																</span>
															</label>
															<div class="border-top pt-2 mt-2">
																<div
																	class="d-flex align-items-center justify-content-between mb-3">
																	<div class="d-flex align-items-center gap-2">
																		<h6 class="fw-bold mb-0">
																			Selected Points
																		</h6>
																		<span class="badge bg-primary rounded-pill">
																			{{ selectedPoints.length }}
																		</span>
																	</div>
																	@if (selectedPoints.length > 0) {
																	<button type="button"
																		class="btn btn-sm btn-outline-danger d-inline-flex align-items-center gap-1 py-1 px-2"
																		(click)="clearAllPoints()">
																		<i class="bi bi-trash3"></i>
																		<span>Clear All</span>
																	</button>
																	}
																</div>
																<div
																	class="selected-chips-container d-flex flex-wrap gap-2 p-1">
																	@for (pin of selectedPoints; track pin.seq) {
																	<span
																		class="badge bg-light text-dark border d-flex align-items-center gap-1 py-1 px-2">
																		<span class="text-muted small">#{{ $index + 1
																			}}</span>
																		<span>{{ pin.body_part }}</span>
																		<i class="bi bi-x ms-1 text-muted chip-remove-btn"
																			(click)="removePoint(pin)"
																			matTooltip="Remove point"></i>
																	</span>
																	} @empty {
																	<span class="text-muted small p-1">
																		No points selected on the map.
																	</span>
																	}
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div class="row g-3">
											<div class="col">
												<div class="row align-items-center justify-content-center">
													<div id="basea"
														class="col-lg-6 col-md-6 col-sm-12 text-center border-end">
														<h6 class="text-muted fw-bold mb-3">Front View</h6>
														<svg version="1.1" xmlns="http://www.w3.org/2000/svg"
															xmlns:xlink="http://www.w3.org/1999/xlink" width="100%"
															height="auto" max-width="300px" viewBox="0 0 734 1370"
															class="anatomy-svg">
															<image width="100%" height="100%"
																href="../assets/vendor/human-anatomy/anatomy-ml-fl-ft-bk/images/modela.png">
															</image>
															<g>
																@for (path of human_anatomy_paths.MF; track path.id) {
																<path [id]="'ana' + path.id" class="anatomy-path"
																	[ngClass]="path.name" [attr.d]="path.d" />
																}
															</g>
															<g>
																@for (pin of human_anatomy_points.MF; track pin.seq) {
																<circle tabindex="0" [attr.cx]="pin.pos_X"
																	[attr.cy]="pin.pos_Y"
																	[attr.r]="humanAnatomyConst.size"
																	[attr.fill]="pin.selected ? colors.selectedColor : colors.upColor"
																	[attr.stroke]="pin.selected ? colors.selectedOutline : colors.upOutline"
																	stroke-width="1" [id]="'anaspotsa_' + $index"
																	[matTooltip]="pin.body_part"
																	(click)="togglePin(pin)"
																	(keyup.enter)="togglePin(pin)"
																	(keyup.space)="togglePin(pin)"
																	class="point-circle" />
																}
															</g>
														</svg>
													</div>
													<div id="baseb" class="col-lg-6 col-md-6 col-sm-12 text-center">
														<h6 class="text-muted fw-bold mb-3">Back View</h6>
														<svg version="1.1" xmlns="http://www.w3.org/2000/svg"
															xmlns:xlink="http://www.w3.org/1999/xlink" width="100%"
															height="auto" max-width="300px" viewBox="0 0 725 1370"
															class="anatomy-svg">
															<image width="100%" height="100%"
																href="../assets/vendor/human-anatomy/anatomy-ml-fl-ft-bk/images/modelb.png">
															</image>
															<g>
																@for (path of human_anatomy_paths.MB; track path.id) {
																<path [id]="'ana' + path.id" class="anatomy-path"
																	[ngClass]="path.name" [attr.d]="path.d" />
																}
															</g>
															<g>
																@for (pin of human_anatomy_points.MB; track pin.seq) {
																<circle tabindex="0" [attr.cx]="pin.pos_X"
																	[attr.cy]="pin.pos_Y"
																	[attr.r]="humanAnatomyConst.size"
																	[attr.fill]="pin.selected ? colors.selectedColor : colors.upColor"
																	[attr.stroke]="pin.selected ? colors.selectedOutline : colors.upOutline"
																	stroke-width="1" [id]="'anaspotsb_' + $index"
																	[matTooltip]="pin.body_part"
																	(click)="togglePin(pin)"
																	(keyup.enter)="togglePin(pin)"
																	(keyup.space)="togglePin(pin)"
																	class="point-circle" />
																}
															</g>
														</svg>
													</div>
												</div>
											</div>

										</div>
									</div>
								</div>
							</div>
						</div>
						<div id="tab2" class="tab-pane" [ngClass]="getTabPaneClass(2)">
							<div class="p-4">
								<mat-accordion [hideToggle]="false">
									<mat-expansion-panel [expanded]="true">
										<mat-expansion-panel-header class="bg-theme" [collapsedHeight]="'35px'"
											[expandedHeight]="'40px'">
											<mat-panel-title>
												<strong class="text-white">
													<i class="bi bi-person-arms-up"></i>
													Major Joint Evaluation
												</strong>
											</mat-panel-title>
										</mat-expansion-panel-header>
										<div class="card border shadow-sm mb-4 card-body p-0 mt-2">
											<div class="table-responsive">
												<table class="table table-bordered align-middle mb-0 rom-table">
													<thead class="table-light">
														<tr>
															<th style="width: 20%;">BODY PART</th>
															<th style="width: 20%;">MOVEMENT</th>
															<th style="width: 30%;">LEFT (Normal Standard)</th>
															<th style="width: 30%;">RIGHT (Normal Standard)</th>
														</tr>
													</thead>
													<tbody>
														<tr>
															<td rowspan="2"
																class="fw-bold align-middle bg-light-subtle">
																Back
															</td>
															<td>
																Flexion / Extension
																<img class="rom-img"
																	src="../../../assets/img/range_of_motion_images/back.png" />
															</td>
															<td>
																<label class="fw-bold small mb-0">
																	Flex (90°)
																</label>
																<div class="w-100">
																	<input type="number" formControlName="back_flexion"
																		class="form-control form-control-sm"
																		[ngClass]="{'is-invalid': showError('back_flexion')}"
																		placeholder="Deg">
																</div>
																@if (showError('back_flexion')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.back_flexion.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.back_flexion.errors?.incorrect) {
																	<span>{{customError.back_flexion}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<label class="fw-bold small mb-0">
																	Ext (25°)
																</label>
																<div class="w-100">
																	<input type="number"
																		formControlName="back_extension"
																		class="form-control form-control-sm"
																		[ngClass]="{'is-invalid': showError('back_extension')}"
																		placeholder="Deg">
																</div>
																@if (showError('back_extension')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.back_extension.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.back_extension.errors?.incorrect) {
																	<span>{{customError.back_extension}}</span>
																	}
																</p>
																}
															</td>
														</tr>
														<tr>
															<td>
																Lateral Flexion
																<img class="rom-img"
																	src="../../../assets/img/range_of_motion_images/lateralflexion.png" />
															</td>
															<td>
																<label class="fw-bold small mb-0">
																	Left (25°)
																</label>
																<div class="w-100">
																	<input type="number"
																		formControlName="back_lateral_flexion_left"
																		class="form-control form-control-sm"
																		[ngClass]="{'is-invalid': showError('back_lateral_flexion_left')}"
																		placeholder="Deg">
																</div>
																@if (showError('back_lateral_flexion_left')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.back_lateral_flexion_left.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.back_lateral_flexion_left.errors?.incorrect)
																	{
																	<span>{{customError.back_lateral_flexion_left}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<label class="fw-bold small mb-0">
																	Right (25°)
																</label>
																<div class="w-100">
																	<input type="number"
																		formControlName="back_lateral_flexion_right"
																		class="form-control form-control-sm"
																		[ngClass]="{'is-invalid': showError('back_lateral_flexion_right')}"
																		placeholder="Deg">
																</div>
																@if (showError('back_lateral_flexion_right')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.back_lateral_flexion_right.errors?.required)
																	{
																	<span>Required</span>
																	}
																	@if (f.back_lateral_flexion_right.errors?.incorrect)
																	{
																	<span>{{customError.back_lateral_flexion_right}}</span>
																	}
																</p>
																}
															</td>
														</tr>
														<tr>
															<td rowspan="2"
																class="fw-bold align-middle bg-light-subtle">
																Neck
															</td>
															<td>
																Flexion / Extension
																<img class="rom-img"
																	src="../../../assets/img/range_of_motion_images/neck.png" />
															</td>
															<td>
																<label class="fw-bold small mb-0">
																	Flex (50°)
																</label>
																<div class="w-100">
																	<input type="number" formControlName="neck_flexion"
																		class="form-control form-control-sm"
																		[ngClass]="{'is-invalid': showError('neck_flexion')}"
																		placeholder="Deg">
																</div>
																@if (showError('neck_flexion')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.neck_flexion.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.neck_flexion.errors?.incorrect) {
																	<span>{{customError.neck_flexion}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<label class="fw-bold small mb-0">
																	Ext (60°)
																</label>
																<div class="w-100">
																	<input type="number"
																		formControlName="neck_extension"
																		class="form-control form-control-sm"
																		[ngClass]="{'is-invalid': showError('neck_extension')}"
																		placeholder="Deg">
																</div>
																@if (showError('neck_extension')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.neck_extension.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.neck_extension.errors?.incorrect) {
																	<span>{{customError.neck_extension}}</span>
																	}
																</p>
																}
															</td>
														</tr>
														<tr>
															<td>
																Lateral Bending
																<img class="rom-img"
																	src="../../../assets/img/range_of_motion_images/neck_lateral_bending.png" />
															</td>
															<td>
																<label class="fw-bold small mb-0">
																	Left (45°)
																</label>
																<div class="w-100">
																	<input type="number"
																		formControlName="neck_extension_lateral_flexion_left"
																		class="form-control form-control-sm"
																		[ngClass]="{'is-invalid': showError('neck_extension_lateral_flexion_left')}"
																		placeholder="Deg">
																</div>
																@if (showError('neck_extension_lateral_flexion_left')) {
																<p class="text-danger small mb-0 mt-1">
																	@if
																	(f.neck_extension_lateral_flexion_left.errors?.required)
																	{
																	<span>Required</span>
																	}
																	@if
																	(f.neck_extension_lateral_flexion_left.errors?.incorrect)
																	{
																	<span>{{customError.neck_extension_lateral_flexion_left}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<label class="fw-bold small mb-0">
																	Right (45°)
																</label>
																<div class="w-100">
																	<input type="number"
																		formControlName="neck_lateral_flexion_right"
																		class="form-control form-control-sm"
																		[ngClass]="{'is-invalid': showError('neck_lateral_flexion_right')}"
																		placeholder="Deg">
																</div>
																@if (showError('neck_lateral_flexion_right')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.neck_lateral_flexion_right.errors?.required)
																	{
																	<span>Required</span>
																	}
																	@if (f.neck_lateral_flexion_right.errors?.incorrect)
																	{
																	<span>{{customError.neck_lateral_flexion_right}}</span>
																	}
																</p>
																}
															</td>
														</tr>
														<tr>
															<td rowspan="2"
																class="fw-bold align-middle bg-light-subtle">
																Shoulder
															</td>
															<td>
																Flexion / Extension
																<img class="rom-img"
																	src="../../../assets/img/range_of_motion_images/shoulder.png" />
															</td>
															<td>
																<label class="fw-bold small mb-0">
																	Flex (180°)
																</label>
																<div class="w-100 mb-1">
																	<input type="number"
																		formControlName="shoulder_left_flexion"
																		class="form-control form-control-sm"
																		[ngClass]="{'is-invalid': showError('shoulder_left_flexion')}"
																		placeholder="Deg">
																</div>
																@if (showError('shoulder_left_flexion')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.shoulder_left_flexion.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.shoulder_left_flexion.errors?.incorrect) {
																	<span>{{customError.shoulder_left_flexion}}</span>
																	}
																</p>
																}
																<label class="fw-bold small mb-0">
																	Ext (50°)
																</label>
																<div class="w-100">
																	<input type="number"
																		formControlName="shoulder_left_extension"
																		class="form-control form-control-sm"
																		[ngClass]="{'is-invalid': showError('shoulder_left_extension')}"
																		placeholder="Deg">
																</div>
																@if (showError('shoulder_left_extension')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.shoulder_left_extension.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.shoulder_left_extension.errors?.incorrect) {
																	<span>{{customError.shoulder_left_extension}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<label class="fw-bold small mb-0">
																	Flex (180°)
																</label>
																<div class="w-100 mb-1">
																	<input type="number"
																		formControlName="shoulder_right_flexion"
																		class="form-control form-control-sm"
																		[ngClass]="{'is-invalid': showError('shoulder_right_flexion')}"
																		placeholder="Deg">
																</div>
																@if (showError('shoulder_right_flexion')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.shoulder_right_flexion.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.shoulder_right_flexion.errors?.incorrect) {
																	<span>{{customError.shoulder_right_flexion}}</span>
																	}
																</p>
																}
																<label class="fw-bold small mb-0">
																	Ext (50°)
																</label>
																<div class="input-group input-group-sm">
																	<input type="number"
																		formControlName="shoulder_right_extension"
																		class="form-control form-control-sm"
																		[ngClass]="{'is-invalid': showError('shoulder_right_extension')}"
																		placeholder="Deg">
																</div>
																@if (showError('shoulder_right_extension')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.shoulder_right_extension.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.shoulder_right_extension.errors?.incorrect) {
																	<span>{{customError.shoulder_right_extension}}</span>
																	}
																</p>
																}
															</td>
														</tr>
														<tr>
															<td>
																Abduction / Adduction
																<img class="rom-img"
																	src="../../../assets/img/range_of_motion_images/shoulder1.png" />
															</td>
															<td>
																<label class="fw-bold small mb-0">
																	Abd (180°)
																</label>
																<div class="w-100 mb-1">
																	<input type="number"
																		formControlName="shoulder_left_abduction"
																		class="form-control form-control-sm"
																		[ngClass]="{'is-invalid': showError('shoulder_left_abduction')}"
																		placeholder="Deg">
																</div>
																@if (showError('shoulder_left_abduction')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.shoulder_left_abduction.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.shoulder_left_abduction.errors?.incorrect) {
																	<span>{{customError.shoulder_left_abduction}}</span>
																	}
																</p>
																}
																<label class="fw-bold small mb-0">
																	Add (30°)
																</label>
																<div class="w-100">
																	<input type="number"
																		formControlName="shoulder_left_adduction"
																		class="form-control form-control-sm"
																		[ngClass]="{'is-invalid': showError('shoulder_left_adduction')}"
																		placeholder="Deg">
																</div>
																@if (showError('shoulder_left_adduction')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.shoulder_left_adduction.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.shoulder_left_adduction.errors?.incorrect) {
																	<span>{{customError.shoulder_left_adduction}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<label class="fw-bold small mb-0">
																	Abd (180°)
																</label>
																<div class="w-100 mb-1">
																	<input type="number"
																		formControlName="shoulder_right_abduction"
																		class="form-control form-control-sm"
																		[ngClass]="{'is-invalid': showError('shoulder_right_abduction')}"
																		placeholder="Deg">
																</div>
																@if (showError('shoulder_right_abduction')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.shoulder_right_abduction.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.shoulder_right_abduction.errors?.incorrect) {
																	<span>{{customError.shoulder_right_abduction}}</span>
																	}
																</p>
																}
																<label class="fw-bold small mb-0">
																	Add (30°)
																</label>
																<div class="w-100">
																	<input type="number"
																		formControlName="shoulder_right_adduction"
																		class="form-control form-control-sm"
																		[ngClass]="{'is-invalid': showError('shoulder_right_adduction')}"
																		placeholder="Deg">
																</div>
																@if (showError('shoulder_right_adduction')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.shoulder_right_adduction.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.shoulder_right_adduction.errors?.incorrect) {
																	<span>{{customError.shoulder_right_adduction}}</span>
																	}
																</p>
																}
															</td>
														</tr>
														<tr>
															<td class="fw-bold align-middle bg-light-subtle">Elbow</td>
															<td>
																Flexion / Extension
																<img class="rom-img"
																	src="../../../assets/img/range_of_motion_images/elbow.png" />
															</td>
															<td>
																<label class="fw-bold small mb-0">
																	Flex (150°)
																</label>
																<div class="w-100 mb-1">
																	<input type="number"
																		formControlName="elbow_left_flexion"
																		class="form-control form-control-sm"
																		[ngClass]="{'is-invalid': showError('elbow_left_flexion')}"
																		placeholder="Deg">
																</div>
																@if (showError('elbow_left_flexion')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.elbow_left_flexion.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.elbow_left_flexion.errors?.incorrect) {
																	<span>{{customError.elbow_left_flexion}}</span>
																	}
																</p>
																}
																<label class="fw-bold small mb-0">
																	Ext (0°)
																</label>
																<div class="w-100">
																	<input type="number"
																		formControlName="elbow_left_extension"
																		class="form-control form-control-sm"
																		[ngClass]="{'is-invalid': showError('elbow_left_extension')}"
																		placeholder="Deg">
																</div>
																@if (showError('elbow_left_extension')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.elbow_left_extension.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.elbow_left_extension.errors?.incorrect) {
																	<span>{{customError.elbow_left_extension}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<label class="fw-bold small mb-0">
																	Flex (150°)
																</label>
																<div class="w-100 mb-1">
																	<input type="number"
																		formControlName="elbow_right_flexion"
																		class="form-control form-control-sm"
																		[ngClass]="{'is-invalid': showError('elbow_right_flexion')}"
																		placeholder="Deg">
																</div>
																@if (showError('elbow_right_flexion')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.elbow_right_flexion.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.elbow_right_flexion.errors?.incorrect) {
																	<span>{{customError.elbow_right_flexion}}</span>
																	}
																</p>
																}
																<label class="fw-bold small mb-0">
																	Ext (0°)
																</label>
																<div class="w-100">
																	<input type="number"
																		formControlName="elbow_right_extension"
																		class="form-control form-control-sm"
																		[ngClass]="{'is-invalid': showError('elbow_right_extension')}"
																		placeholder="Deg">
																</div>
																@if (showError('elbow_right_extension')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.elbow_right_extension.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.elbow_right_extension.errors?.incorrect) {
																	<span>{{customError.elbow_right_extension}}</span>
																	}
																</p>
																}
															</td>
														</tr>
														<tr>
															<td class="fw-bold align-middle bg-light-subtle">Knee</td>
															<td>
																Flexion
																<img class="rom-img"
																	src="../../../assets/img/range_of_motion_images/knee.png" />
															</td>
															<td>
																<label class="fw-bold small mb-0">
																	Flex (150°)
																</label>
																<div class="w-100">
																	<input type="number"
																		formControlName="knee_left_flexion"
																		class="form-control form-control-sm"
																		[ngClass]="{'is-invalid': showError('knee_left_flexion')}"
																		placeholder="Deg">
																</div>
																@if (showError('knee_left_flexion')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.knee_left_flexion.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.knee_left_flexion.errors?.incorrect) {
																	<span>{{customError.knee_left_flexion}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<label class="fw-bold small mb-0">
																	Flex (150°)
																</label>
																<div class="w-100">
																	<input type="number"
																		formControlName="knee_right_flexion"
																		class="form-control form-control-sm"
																		[ngClass]="{'is-invalid': showError('knee_right_flexion')}"
																		placeholder="Deg">
																</div>
																@if (showError('knee_right_flexion')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.knee_right_flexion.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.knee_right_flexion.errors?.incorrect) {
																	<span>{{customError.knee_right_flexion}}</span>
																	}
																</p>
																}
															</td>
														</tr>
														<tr>
															<td rowspan="2"
																class="fw-bold align-middle bg-light-subtle">
																Ankle
															</td>
															<td>
																Inversion / Eversion
																<img class="rom-img"
																	src="../../../assets/img/range_of_motion_images/ankle.png" />
															</td>
															<td>
																<p
																	class="text-center text-muted fw-semibold small mb-0 border-bottom">
																	Left
																</p>
																<label class="fw-bold small mb-0">
																	Inv (30°)
																</label>
																<div class="w-100 mb-1">
																	<input type="number"
																		formControlName="ankle_left_inversion"
																		class="form-control form-control-sm"
																		[ngClass]="{'is-invalid': showError('ankle_left_inversion')}"
																		placeholder="Deg">
																</div>
																@if (showError('ankle_left_inversion')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.ankle_left_inversion.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.ankle_left_inversion.errors?.incorrect) {
																	<span>{{customError.ankle_left_inversion}}</span>
																	}
																</p>
																}
																<label class="fw-bold small mb-0">
																	Eve (20°)
																</label>
																<div class="w-100">
																	<input type="number"
																		formControlName="ankle_left_eversion"
																		class="form-control form-control-sm"
																		[ngClass]="{'is-invalid': showError('ankle_left_eversion')}"
																		placeholder="Deg">
																</div>
																@if (showError('ankle_left_eversion')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.ankle_left_eversion.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.ankle_left_eversion.errors?.incorrect) {
																	<span>{{customError.ankle_left_eversion}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<p
																	class="text-center text-muted fw-semibold small mb-0 border-bottom">
																	Right
																</p>
																<label class="fw-bold small mb-0">
																	Inv (30°)
																</label>
																<div class="w-100 mb-1">
																	<input type="number"
																		formControlName="ankle_right_inversion"
																		class="form-control form-control-sm"
																		[ngClass]="{'is-invalid': showError('ankle_right_inversion')}"
																		placeholder="Deg">
																</div>
																@if (showError('ankle_right_inversion')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.ankle_right_inversion.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.ankle_right_inversion.errors?.incorrect) {
																	<span>{{customError.ankle_right_inversion}}</span>
																	}
																</p>
																}
																<label class="fw-bold small mb-0">
																	Eve (20°)
																</label>
																<div class="w-100">
																	<input type="number"
																		formControlName="ankle_right_eversion"
																		class="form-control form-control-sm"
																		[ngClass]="{'is-invalid': showError('ankle_right_eversion')}"
																		placeholder="Deg">
																</div>
																@if (showError('ankle_right_eversion')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.ankle_right_eversion.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.ankle_right_eversion.errors?.incorrect) {
																	<span>{{customError.ankle_right_eversion}}</span>
																	}
																</p>
																}
															</td>
														</tr>
														<tr>
															<td>
																Plantar / Dorsal
																<img class="rom-img"
																	src="../../../assets/img/range_of_motion_images/ankle1.png" />
															</td>
															<td>
																<p
																	class="text-center text-muted fw-semibold small mb-0 border-bottom">
																	Left
																</p>
																<label class="fw-bold small mb-0">
																	Plantar (40°)
																</label>
																<div class="w-100 mb-1">
																	<input type="number"
																		formControlName="ankle_left_plantar"
																		class="form-control form-control-sm"
																		[ngClass]="{'is-invalid': showError('ankle_left_plantar')}"
																		placeholder="Deg">
																</div>
																@if (showError('ankle_left_plantar')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.ankle_left_plantar.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.ankle_left_plantar.errors?.incorrect) {
																	<span>{{customError.ankle_left_plantar}}</span>
																	}
																</p>
																}
																<label class="fw-bold small mb-0">
																	Dorsal (20°)
																</label>
																<div class="w-100">
																	<input type="number"
																		formControlName="ankle_left_dorsal"
																		class="form-control form-control-sm"
																		[ngClass]="{'is-invalid': showError('ankle_left_dorsal')}"
																		placeholder="Deg">
																</div>
																@if (showError('ankle_left_dorsal')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.ankle_left_dorsal.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.ankle_left_dorsal.errors?.incorrect) {
																	<span>{{customError.ankle_left_dorsal}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<p
																	class="text-center text-muted fw-semibold small mb-0 border-bottom">
																	Right
																</p>
																<label class="fw-bold small mb-0">
																	Plantar (40°)
																</label>
																<div class="w-100 mb-1">
																	<input type="number"
																		formControlName="ankle_right_plantar"
																		class="form-control form-control-sm"
																		[ngClass]="{'is-invalid': showError('ankle_right_plantar')}"
																		placeholder="Deg">
																</div>
																@if (showError('ankle_right_plantar')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.ankle_right_plantar.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.ankle_right_plantar.errors?.incorrect) {
																	<span>{{customError.ankle_right_plantar}}</span>
																	}
																</p>
																}
																<label class="fw-bold small mb-0">
																	Dorsal (20°)
																</label>
																<div class="w-100">
																	<input type="number"
																		formControlName="ankle_right_dorsal"
																		class="form-control form-control-sm"
																		[ngClass]="{'is-invalid': showError('ankle_right_dorsal')}"
																		placeholder="Deg">
																</div>
																@if (showError('ankle_right_dorsal')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.ankle_right_dorsal.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.ankle_right_dorsal.errors?.incorrect) {
																	<span>{{customError.ankle_right_dorsal}}</span>
																	}
																</p>
																}
															</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</mat-expansion-panel>
									<mat-expansion-panel [expanded]="false">
										<mat-expansion-panel-header class="bg-theme" [collapsedHeight]="'35px'"
											[expandedHeight]="'40px'">
											<mat-panel-title>
												<strong class="text-white">
													<i class="bi bi-hand-thumbs-up"></i>
													Wrist & Forearm
												</strong>
											</mat-panel-title>
										</mat-expansion-panel-header>
										<div class="card border shadow-sm mb-4 card-body p-0 mt-2">
											<div class="table-responsive">
												<table
													class="table table-bordered align-middle text-center mb-0 rom-table">
													<thead class="table-light">
														<tr>
															<th style="width: 40%;">MOVEMENT</th>
															<th style="width: 30%;">LEFT</th>
															<th style="width: 30%;">RIGHT</th>
														</tr>
													</thead>
													<tbody>
														<tr>
															<td>
																Flexion (0° - 80°)
																<img class="rom-img"
																	src="../../../assets/img/range_of_motion_images/wrist_flex.png" />
															</td>
															<td>
																<input type="number"
																	formControlName="wrist_left_flexion"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('wrist_left_flexion')}"
																	placeholder="Deg">
																@if (showError('wrist_left_flexion')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.wrist_left_flexion.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.wrist_left_flexion.errors?.incorrect) {
																	<span>{{customError.wrist_left_flexion}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<input type="number"
																	formControlName="wrist_right_flexion"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('wrist_right_flexion')}"
																	placeholder="Deg">
																@if (showError('wrist_right_flexion')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.wrist_right_flexion.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.wrist_right_flexion.errors?.incorrect) {
																	<span>{{customError.wrist_right_flexion}}</span>
																	}
																</p>
																}
															</td>
														</tr>
														<tr>
															<td>
																Extension (0° - 70°)
																<img class="rom-img"
																	src="../../../assets/img/range_of_motion_images/wrist_ext.png" />
															</td>
															<td>
																<input type="number"
																	formControlName="wrist_left_extension"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('wrist_left_extension')}"
																	placeholder="Deg">
																@if (showError('wrist_left_extension')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.wrist_left_extension.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.wrist_left_extension.errors?.incorrect) {
																	<span>{{customError.wrist_left_extension}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<input type="number"
																	formControlName="wrist_right_extension"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('wrist_right_extension')}"
																	placeholder="Deg">
																@if (showError('wrist_right_extension')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.wrist_right_extension.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.wrist_right_extension.errors?.incorrect) {
																	<span>{{customError.wrist_right_extension}}</span>
																	}
																</p>
																}
															</td>
														</tr>
														<tr>
															<td>
																Radial Deviation (0° - 20°)
																<img class="rom-img"
																	src="../../../assets/img/range_of_motion_images/wrist_rad.png" />
															</td>
															<td>
																<input type="number"
																	formControlName="wrist_left_radial_extension"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('wrist_left_radial_extension')}"
																	placeholder="Deg">
																@if (showError('wrist_left_radial_extension')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.wrist_left_radial_extension.errors?.required)
																	{
																	<span>Required</span>
																	}
																	@if
																	(f.wrist_left_radial_extension.errors?.incorrect) {
																	<span>{{customError.wrist_left_radial_extension}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<input type="number"
																	formControlName="wrist_right_radial_extension"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('wrist_right_radial_extension')}"
																	placeholder="Deg">
																@if (showError('wrist_right_radial_extension')) {
																<p class="text-danger small mb-0 mt-1">
																	@if
																	(f.wrist_right_radial_extension.errors?.required) {
																	<span>Required</span>
																	}
																	@if
																	(f.wrist_right_radial_extension.errors?.incorrect) {
																	<span>{{customError.wrist_right_radial_extension}}</span>
																	}
																</p>
																}
															</td>
														</tr>
														<tr>
															<td>
																Ulnar Deviation (0° - 30°)
																<img class="rom-img"
																	src="../../../assets/img/range_of_motion_images/wrist_ulnar.png" />
															</td>
															<td>
																<input type="number"
																	formControlName="wrist_left_ulnar_extension"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('wrist_left_ulnar_extension')}"
																	placeholder="Deg">
																@if (showError('wrist_left_ulnar_extension')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.wrist_left_ulnar_extension.errors?.required)
																	{
																	<span>Required</span>
																	}
																	@if (f.wrist_left_ulnar_extension.errors?.incorrect)
																	{
																	<span>{{customError.wrist_left_ulnar_extension}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<input type="number"
																	formControlName="wrist_right_ulnar_extension"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('wrist_right_ulnar_extension')}"
																	placeholder="Deg">
																@if (showError('wrist_right_ulnar_extension')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.wrist_right_ulnar_extension.errors?.required)
																	{
																	<span>Required</span>
																	}
																	@if
																	(f.wrist_right_ulnar_extension.errors?.incorrect) {
																	<span>{{customError.wrist_right_ulnar_extension}}</span>
																	}
																</p>
																}
															</td>
														</tr>
														<tr>
															<td>
																Pronation (0° - 90°)
																<img class="rom-img"
																	src="../../../assets/img/range_of_motion_images/forearm_pron.png" />
															</td>
															<td>
																<input type="number"
																	formControlName="wrist_left_pronation"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('wrist_left_pronation')}"
																	placeholder="Deg">
																@if (showError('wrist_left_pronation')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.wrist_left_pronation.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.wrist_left_pronation.errors?.incorrect) {
																	<span>{{customError.wrist_left_pronation}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<input type="number"
																	formControlName="wrist_right_pronation"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('wrist_right_pronation')}"
																	placeholder="Deg">
																@if (showError('wrist_right_pronation')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.wrist_right_pronation.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.wrist_right_pronation.errors?.incorrect) {
																	<span>{{customError.wrist_right_pronation}}</span>
																	}
																</p>
																}
															</td>
														</tr>
														<tr>
															<td>
																Supination (0° - 90°)
																<img class="rom-img"
																	src="../../../assets/img/range_of_motion_images/forearm_supin.png" />
															</td>
															<td>
																<input type="number"
																	formControlName="wrist_left_supination"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('wrist_left_supination')}"
																	placeholder="Deg">
																@if (showError('wrist_left_supination')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.wrist_left_supination.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.wrist_left_supination.errors?.incorrect) {
																	<span>{{customError.wrist_left_supination}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<input type="number"
																	formControlName="wrist_right_supination"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('wrist_right_supination')}"
																	placeholder="Deg">
																@if (showError('wrist_right_supination')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.wrist_right_supination.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.wrist_right_supination.errors?.incorrect) {
																	<span>{{customError.wrist_right_supination}}</span>
																	}
																</p>
																}
															</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</mat-expansion-panel>
									<mat-expansion-panel [expanded]="false">
										<mat-expansion-panel-header class="bg-theme" [collapsedHeight]="'35px'"
											[expandedHeight]="'40px'">
											<mat-panel-title>
												<strong class="text-white">
													<i class="bi bi-hand-index"></i>
													Hand & Fingers
												</strong>
											</mat-panel-title>
										</mat-expansion-panel-header>
										<div class="card border shadow-sm mb-4 card-body p-0 mt-2">
											<div class="table-responsive">
												<table
													class="table table-bordered align-middle text-center mb-0 rom-table">
													<thead class="table-light">
														<tr>
															<th style="width: 35%;">MOVEMENT</th>
															<th>THUMB</th>
															<th>INDEX</th>
															<th>MIDDLE</th>
															<th>RING</th>
															<th>LITTLE</th>
														</tr>
													</thead>
													<tbody>
														<tr>
															<td class="text-start ps-3">
																MCP Flexion (0° - 90°)
																<img class="rom-img"
																	src="../../../assets/img/range_of_motion_images/mcp_flex.png" />
															</td>
															<td>
																<input type="number" formControlName="thumb_mcp_flexion"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('thumb_mcp_flexion')}">
																@if (showError('thumb_mcp_flexion')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.thumb_mcp_flexion.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.thumb_mcp_flexion.errors?.incorrect) {
																	<span>{{customError.thumb_mcp_flexion}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<input type="number" formControlName="index_mcp_flexion"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('index_mcp_flexion')}">
																@if (showError('index_mcp_flexion')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.index_mcp_flexion.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.index_mcp_flexion.errors?.incorrect) {
																	<span>{{customError.index_mcp_flexion}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<input type="number"
																	formControlName="middle_mcp_flexion"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('middle_mcp_flexion')}">
																@if (showError('middle_mcp_flexion')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.middle_mcp_flexion.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.middle_mcp_flexion.errors?.incorrect) {
																	<span>{{customError.middle_mcp_flexion}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<input type="number" formControlName="ring_mcp_flexion"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('ring_mcp_flexion')}">
																@if (showError('ring_mcp_flexion')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.ring_mcp_flexion.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.ring_mcp_flexion.errors?.incorrect) {
																	<span>{{customError.ring_mcp_flexion}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<input type="number"
																	formControlName="little_mcp_flexion"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('little_mcp_flexion')}">
																@if (showError('little_mcp_flexion')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.little_mcp_flexion.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.little_mcp_flexion.errors?.incorrect) {
																	<span>{{customError.little_mcp_flexion}}</span>
																	}
																</p>
																}
															</td>
														</tr>
														<tr>
															<td class="text-start ps-3">
																PIP Flexion (0° - 100°)
																<img class="rom-img"
																	src="../../../assets/img/range_of_motion_images/pip_flex.png" />
															</td>
															<td>
																<input type="number" formControlName="thumb_pip_flexion"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('thumb_pip_flexion')}">
																@if (showError('thumb_pip_flexion')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.thumb_pip_flexion.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.thumb_pip_flexion.errors?.incorrect) {
																	<span>{{customError.thumb_pip_flexion}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<input type="number" formControlName="index_pip_flexion"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('index_pip_flexion')}">
																@if (showError('index_pip_flexion')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.index_pip_flexion.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.index_pip_flexion.errors?.incorrect) {
																	<span>{{customError.index_pip_flexion}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<input type="number"
																	formControlName="middle_pip_flexion"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('middle_pip_flexion')}">
																@if (showError('middle_pip_flexion')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.middle_pip_flexion.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.middle_pip_flexion.errors?.incorrect) {
																	<span>{{customError.middle_pip_flexion}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<input type="number" formControlName="ring_pip_flexion"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('ring_pip_flexion')}">
																@if (showError('ring_pip_flexion')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.ring_pip_flexion.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.ring_pip_flexion.errors?.incorrect) {
																	<span>{{customError.ring_pip_flexion}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<input type="number"
																	formControlName="little_pip_flexion"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('little_pip_flexion')}">
																@if (showError('little_pip_flexion')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.little_pip_flexion.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.little_pip_flexion.errors?.incorrect) {
																	<span>{{customError.little_pip_flexion}}</span>
																	}
																</p>
																}
															</td>
														</tr>
														<tr>
															<td class="text-start ps-3">
																DIP Flexion (0° - 70°)
																<img class="rom-img"
																	src="../../../assets/img/range_of_motion_images/dip_flex.png" />
															</td>
															<td>
																<input type="number" formControlName="thumb_dip_flexion"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('thumb_dip_flexion')}">
																@if (showError('thumb_dip_flexion')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.thumb_dip_flexion.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.thumb_dip_flexion.errors?.incorrect) {
																	<span>{{customError.thumb_dip_flexion}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<input type="number" formControlName="index_dip_flexion"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('index_dip_flexion')}">
																@if (showError('index_dip_flexion')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.index_dip_flexion.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.index_dip_flexion.errors?.incorrect) {
																	<span>{{customError.index_dip_flexion}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<input type="number"
																	formControlName="middle_dip_flexion"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('middle_dip_flexion')}">
																@if (showError('middle_dip_flexion')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.middle_dip_flexion.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.middle_dip_flexion.errors?.incorrect) {
																	<span>{{customError.middle_dip_flexion}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<input type="number" formControlName="ring_dip_flexion"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('ring_dip_flexion')}">
																@if (showError('ring_dip_flexion')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.ring_dip_flexion.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.ring_dip_flexion.errors?.incorrect) {
																	<span>{{customError.ring_dip_flexion}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<input type="number"
																	formControlName="little_dip_flexion"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('little_dip_flexion')}">
																@if (showError('little_dip_flexion')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.little_dip_flexion.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.little_dip_flexion.errors?.incorrect) {
																	<span>{{customError.little_dip_flexion}}</span>
																	}
																</p>
																}
															</td>
														</tr>
														<tr>
															<td class="text-start ps-3">
																Finger Abduction (0° - 30° to 40°)
																<img class="rom-img"
																	src="../../../assets/img/range_of_motion_images/finger_abduct.png" />
															</td>
															<td>
																<input type="number" formControlName="thumb_abduction"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('thumb_abduction')}">
																@if (showError('thumb_abduction')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.thumb_abduction.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.thumb_abduction.errors?.incorrect) {
																	<span>{{customError.thumb_abduction}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<input type="number" formControlName="index_abduction"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('index_abduction')}">
																@if (showError('index_abduction')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.index_abduction.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.index_abduction.errors?.incorrect) {
																	<span>{{customError.index_abduction}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<input type="number" formControlName="middle_abduction"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('middle_abduction')}">
																@if (showError('middle_abduction')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.middle_abduction.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.middle_abduction.errors?.incorrect) {
																	<span>{{customError.middle_abduction}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<input type="number" formControlName="ring_abduction"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('ring_abduction')}">
																@if (showError('ring_abduction')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.ring_abduction.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.ring_abduction.errors?.incorrect) {
																	<span>{{customError.ring_abduction}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<input type="number" formControlName="little_abduction"
																	class="form-control form-control-sm text-center"
																	[ngClass]="{'is-invalid': showError('little_abduction')}">
																@if (showError('little_abduction')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.little_abduction.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.little_abduction.errors?.incorrect) {
																	<span>{{customError.little_abduction}}</span>
																	}
																</p>
																}
															</td>
														</tr>
														<tr>
															<td class="text-start ps-3">
																Finger Opposition (Yes / No)
																<img class="rom-img"
																	src="../../../assets/img/range_of_motion_images/finger_opposite.png" />
															</td>
															<td>
																<mat-radio-group formControlName="thumb_opposition"
																	class="d-flex flex-column align-items-center"
																	[ngClass]="{'is-invalid': showError('thumb_opposition')}">
																	<mat-radio-button [value]="true"
																		class="color-success">Yes</mat-radio-button>
																	<mat-radio-button [value]="false"
																		class="color-danger">No</mat-radio-button>
																</mat-radio-group>
																@if (showError('thumb_opposition')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.thumb_opposition.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.thumb_opposition.errors?.incorrect) {
																	<span>{{customError.thumb_opposition}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<mat-radio-group formControlName="index_opposition"
																	class="d-flex flex-column align-items-center"
																	[ngClass]="{'is-invalid': showError('index_opposition')}">
																	<mat-radio-button [value]="true"
																		class="color-success">Yes</mat-radio-button>
																	<mat-radio-button [value]="false"
																		class="color-danger">No</mat-radio-button>
																</mat-radio-group>
																@if (showError('index_opposition')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.index_opposition.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.index_opposition.errors?.incorrect) {
																	<span>{{customError.index_opposition}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<mat-radio-group formControlName="middle_opposition"
																	class="d-flex flex-column align-items-center"
																	[ngClass]="{'is-invalid': showError('middle_opposition')}">
																	<mat-radio-button [value]="true"
																		class="color-success">Yes</mat-radio-button>
																	<mat-radio-button [value]="false"
																		class="color-danger">No</mat-radio-button>
																</mat-radio-group>
																@if (showError('middle_opposition')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.middle_opposition.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.middle_opposition.errors?.incorrect) {
																	<span>{{customError.middle_opposition}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<mat-radio-group formControlName="ring_opposition"
																	class="d-flex flex-column align-items-center"
																	[ngClass]="{'is-invalid': showError('ring_opposition')}">
																	<mat-radio-button [value]="true"
																		class="color-success">Yes</mat-radio-button>
																	<mat-radio-button [value]="false"
																		class="color-danger">No</mat-radio-button>
																</mat-radio-group>
																@if (showError('ring_opposition')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.ring_opposition.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.ring_opposition.errors?.incorrect) {
																	<span>{{customError.ring_opposition}}</span>
																	}
																</p>
																}
															</td>
															<td>
																<mat-radio-group formControlName="little_opposition"
																	class="d-flex flex-column align-items-center"
																	[ngClass]="{'is-invalid': showError('little_opposition')}">
																	<mat-radio-button [value]="true"
																		class="color-success">Yes</mat-radio-button>
																	<mat-radio-button [value]="false"
																		class="color-danger">No</mat-radio-button>
																</mat-radio-group>
																@if (showError('little_opposition')) {
																<p class="text-danger small mb-0 mt-1">
																	@if (f.little_opposition.errors?.required) {
																	<span>Required</span>
																	}
																	@if (f.little_opposition.errors?.incorrect) {
																	<span>{{customError.little_opposition}}</span>
																	}
																</p>
																}
															</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</mat-expansion-panel>
									<mat-expansion-panel [expanded]="false">
										<mat-expansion-panel-header class="bg-theme" [collapsedHeight]="'35px'"
											[expandedHeight]="'40px'">
											<mat-panel-title>
												<strong class="text-white">
													<i class="bi bi-emoji-smile"></i>
													Jaw (Temporomandibular Joint)
												</strong>
											</mat-panel-title>
										</mat-expansion-panel-header>
										<div class="card border shadow-sm mb-4 card-body p-3 mt-2">
											<div class="row align-items-center justify-content-center">
												<div class="col-md-6 border-end text-center">
													<span class="fw-bold d-block mb-1">
														Mouth Opening (Inter-incisal distance)
													</span>
													<span class="text-muted small d-block mb-2">(Normal: 35 - 50
														mm)</span>
													<img class="rom-img"
														src="../../../assets/img/range_of_motion_images/mouth_open.png" />
												</div>
												<div class="col-md-4">
													<div class="input-group input-group-sm">
														<input type="number" formControlName="mouth_opening"
															class="form-control"
															[ngClass]="{'is-invalid': showError('mouth_opening')}"
															placeholder="Measured Value">
														<select formControlName="mouth_opening_unit" class="form-select"
															style="max-width: 90px;"
															[ngClass]="{'is-invalid': showError('mouth_opening_unit')}">
															<option value="mm">mm</option>
															<option value="cm">cm</option>
														</select>
													</div>
													@if (showError('mouth_opening')) {
													<p class="text-danger small mb-0 mt-1">
														@if (f.mouth_opening.errors?.required) {
														<span>Required</span>
														}
														@if (f.mouth_opening.errors?.incorrect) {
														<span>{{customError.mouth_opening}}</span>
														}
													</p>
													}
													@if (showError('mouth_opening_unit')) {
													<p class="text-danger small mb-0 mt-1">
														@if (f.mouth_opening_unit.errors?.required) {
														<span>Required</span>
														}
														@if (f.mouth_opening_unit.errors?.incorrect) {
														<span>{{customError.mouth_opening_unit}}</span>
														}
													</p>
													}
												</div>
											</div>
										</div>
									</mat-expansion-panel>
								</mat-accordion>
							</div>
						</div>
					</div>
					<ng-container *ngTemplateOutlet="actionButtons"></ng-container>
				</form>
			</div>
		</div>
	</div>
	<div class="col-6 main-col">
		<div class="card">
			<div class="card-header mb-0">
				<h5 class="card-title mb-0">
					Report
					@if (fileURL) {
					<a [href]="fileURL" target="_blank" rel="noopener noreferrer"
						class="btn btn-sm btn-primary text-light fw-medium float-end"
						matTooltip="Open report in new tab">
						<i class="bi bi-box-arrow-up-right me-1"></i>
						Open Fullscreen
					</a>
					}
					@if(blob){
					<button class="btn btn-sm btn-success text-light fw-medium float-end me-1" matTooltip="Download PDF"
						(click)="downloadReportPDF()">
						<i class="bi bi-download me-1"></i>
						Download
					</button>
					}
				</h5>
			</div>
			<div class="card-body pt-2">
				@if (isLoadingReport) {
				<div class="text-center">
					<img src="../../../assets/img/loading.gif" style="width: 100px;" />
					<p style="color: black;font-weight: bolder;">Loading...</p>
				</div>
				}@else {
				@if (fileURL) {
				<div class="pdf-container">
					<iframe [src]="fileURL" type="application/pdf" class="w-100 border-0 d-block">
					</iframe>
				</div>
				} @else {
				<div class="text-center py-5 my-4 text-muted">
					<i class="bi bi-file-earmark-x display-4 d-block mb-3 text-secondary"></i>
					<h6 class="fw-bold">No Report Available</h6>
					<p class="small mb-0">The report document is not available at this time.</p>
				</div>
				}
				}
			</div>
		</div>
	</div>
</div>
}@else {
<div>
	<h3 class="text-center">You don't have access to this section.</h3>
</div>
}
<ng-template #actionButtons>
	<div class="d-flex justify-content-end align-items-center gap-2 pt-0">
		<a type="button" class="btn btn-sm btn-secondary px-4" [routerLink]="['/app/appt-details/no',uId,followId]">
			<fa-icon [icon]="['fas','arrow-left']"></fa-icon>
			Back
		</a>
		<button type="submit" class="btn btn-sm btn-primary px-4" [disabled]="isSubmitting">
			@if (isSubmitting) {
			<fa-icon [icon]="['fas','spinner']" animation="spin"></fa-icon>
			} @else {
			<fa-icon [icon]="['fas','save']"></fa-icon>
			}
			Submit
		</button>
	</div>
</ng-template>
<div class="modal fade" id="image_signature_modal" tabindex="-1" role="dialog" data-bs-backdrop="static">
	<div class="modal-dialog modal-lg modal-dialog-centered">
		<div class="modal-content shadow">
			<div class="modal-header bg-light py-2">
				<h5 class="modal-title fw-semibold">
					Upload Candidate
					{{ photo_or_sign === 'photo' ? 'Photo' : 'Signature' }}
				</h5>
				<button type="button" class="btn-close" (click)="closeImageModal()"></button>
			</div>
			<div class="modal-body position-relative p-4">
				@if (imageUploadLoader) {
				<div class="position-absolute top-0 start-0 w-100 h-100 bg-white bg-opacity-75 d-flex align-items-center justify-content-center"
					style="z-index: 1050;">
					<img src="../../../assets/img/loading.gif" alt="Loading..." width="48" height="48" />
				</div>
				}
				<div class="row align-items-center g-4">
					<div class="col-lg-5">
						@if (photo_or_sign === 'photo') {
						<div class="d-flex flex-column align-items-center gap-2">
							@if (isCameraExist) {
							@if (showWebcam) {
							<div class="border rounded overflow-hidden shadow-sm bg-black">
								<webcam [height]="250" [width]="330" [trigger]="triggerObservable"
									(imageCapture)="handleImage($event)" [switchCamera]="nextWebcamObservable">
								</webcam>
							</div>
							}
							@if (errors.length) {
							<div class="alert alert-danger w-100 mt-2 p-2 small" role="alert">
								<strong class="d-block mb-1">Camera Errors:</strong>
								<ul class="mb-0 ps-3">
									@for (error of errors; track $index) {
									<li>{{ error | json }}</li>
									}
								</ul>
							</div>
							}
							<button type="button" class="btn btn-sm btn-primary px-3 mt-1" (click)="takeSnapshot()">
								<fa-icon [icon]="['fas','camera']" class="me-1"></fa-icon>
								Capture
							</button>
							} @else {
							<div class="alert alert-warning text-center w-100 mb-0" role="alert">
								Camera device not available.
							</div>
							}
						</div>
						} @else {
						<div class="d-flex flex-column align-items-center gap-2">
							<span class="text-muted small fw-bold">Draw Signature Below</span>
							<div class="border rounded bg-white shadow-sm p-1">
								<canvas #signatureCanvas width="320" height="180"
									class="d-block border rounded-1 bg-light-subtle"
									style="cursor: crosshair;"></canvas>
							</div>
							<div class="d-flex gap-2 mt-1">
								<button type="button" class="btn btn-sm btn-outline-secondary px-3"
									(click)="clearSignature()">
									<fa-icon [icon]="['fas','eraser']" class="me-1"></fa-icon>
									Clear
								</button>
								<button type="button" class="btn btn-sm btn-primary px-3" (click)="saveSignature()">
									<fa-icon [icon]="['fas','save']" class="me-1"></fa-icon>
									Save Signature
								</button>
							</div>
						</div>
						}
					</div>
					<div class="col-lg-2 d-flex justify-content-center align-items-center py-2">
						<div class="d-flex flex-lg-column align-items-center gap-2 text-muted">
							<hr class="w-100 d-lg-none my-0" />
							<span
								class="badge rounded-pill bg-light text-secondary border fw-normal px-3 py-2">OR</span>
							<hr class="w-100 d-lg-none my-0" />
						</div>
					</div>
					<div class="col-lg-5">
						<div class="p-2 border rounded bg-light-subtle text-center">
							<span class="d-block text-muted small fw-bold mb-2">Upload File From Device</span>
							<app-file-upload [allowedFiles]="allowedImageFiles" [uploadFolder]="photo_folder"
								(uploaded)="imageUploaded($event)" [flag]="true">
							</app-file-upload>
						</div>
					</div>
				</div>
			</div>
			<div class="modal-footer bg-light py-2">
				<button type="button" class="btn btn-sm btn-secondary px-3" (click)="closeImageModal()">
					Cancel
				</button>
			</div>
		</div>
	</div>
</div>
<!-- <div class="modal fade" id="image_signature_modal" role="dialog" data-bs-backdrop="static">
	<div class="modal-dialog modal-fullscreen">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title">
					<strong>
						Upload Candidate
						{{ photo_or_sign == 'photo' ? 'Photo' : 'Signature' }}
					</strong>
				</h4>
				<button type="button" class="btn-close" (click)="closeImageModal()"></button>
			</div>
			<div class="modal-body">
				@if (imageUploadLoader) {
				<div class="loader text-center">
					<div class="col-md-12">
						<img src="../../../assets/img/loading.gif" />
					</div>
				</div>
				}
				<div class="row">
					<div class="col-md-5">
						@if (photo_or_sign == 'photo') {
						<div class="row">
							<div class="col-md-12">
								@if (isCameraExist) {
								<div class="text-center">
									@if (showWebcam) {
									<webcam [height]="300" [width]="400" [trigger]="triggerObservable"
										(imageCapture)="handleImage($event)" [switchCamera]="nextWebcamObservable">
									</webcam>
									}
								</div>
								@if (errors.length) {
								<h4>Error Messages:</h4>
								@for (error of errors; track $index) {
								<ul>
									<li>{{ error | json }}</li>
								</ul>
								}
								}
								}@else {
								Camera device not available
								}
							</div>
						</div>
						<div class="row">
							<div class="col-md-12 text-center">
								<button class="btn btn-sm btn-primary" (click)="takeSnapshot()">
									<fa-icon [icon]="['fas','camera']"></fa-icon>
									Capture
								</button>
							</div>
						</div>
						}@else {
						<div class="d-flex flex-column align-items-center">
							<div class="border rounded bg-white shadow-sm p-2 mb-2">
								<canvas #signatureCanvas width="400" height="200" class="border"></canvas>
							</div>
							<div class="d-flex gap-2">
								<button type="button" class="btn btn-sm btn-outline-secondary"
									(click)="clearSignature()">
									Clear
								</button>
								<button type="button" class="btn btn-sm btn-primary" (click)="saveSignature()">
									<fa-icon [icon]="['fas','save']"></fa-icon>
									Save Signature
								</button>
							</div>
						</div>
						}
					</div>
					<div class="col-md-2">
						<br />
						<br />
						<br />
						<h3 class="text-center">OR</h3>
					</div>
					<div class="col-md-5">
						<app-file-upload [allowedFiles]="allowedImageFiles" [uploadFolder]="photo_folder"
							(uploaded)="imageUploaded($event)" [flag]="true">
						</app-file-upload>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button class="btn btn-sm btn-warning pull-right" (click)="closeImageModal()">
					Cancel
				</button>
			</div>
		</div>
	</div>
</div> -->